import {
  FormHelperText,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import TableRow from "@material-ui/core/TableRow";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { DatePicker } from "@material-ui/pickers";
import { useTheme } from "@material-ui/styles";
import AddRowButton from "components/common/AddRowButton";
import {
  Bagde,
  StyledTableCell,
  TableRowHead,
  UploadButton,
  useStyles,
} from "components/request-document/components/Commons";
import SelectCountryDialog from "components/request-document/components/SelectCountryDialog";
import { openFileById } from "libs/utils/file";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash-es";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";
import FileService from "services/FileService";

export default function WorkExperienceSection({
  formik,
  defaultWorkExperience,
  bagde = 20,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const masterData = useSelector(selectMasterData);
  const countryConfig = get(masterData, "countryConfig", []);

  const WorkExperienceTable = formik.values.document.WorkExperienceTable;
  const canEdit = useSelector(canEditForm);

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <Typography variant="h6" className={classes.title}>
                Work experience (past 10 years)
              </Typography>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRowHead>
        <StyledTableCell>
          <div className={classes.cellContent}>
            {/* <Bagde number={0} /> */}
            <div className={classes.wrapField}>
              <InputLabel>Period ( mm-yyyy to mm-yyyy )</InputLabel>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell>
          <InputLabel>Name of organization</InputLabel>
        </StyledTableCell>
        <StyledTableCell>
          <InputLabel>City / Country</InputLabel>
        </StyledTableCell>
        <StyledTableCell>
          <InputLabel>Responsibility</InputLabel>
        </StyledTableCell>
        <StyledTableCell></StyledTableCell>
      </TableRowHead>

      {WorkExperienceTable.map((experience, index) => {
        if (!experience.Status) return null;

        return (
          <TableRow key={experience.workId + "-" + index}>
            <StyledTableCell>
              <div
                style={{ width: 200, display: "flex", flexDirection: "row" }}
              >
                <DatePicker
                  disabled={!canEdit}
                  // className={classes.formControl}
                  style={{ minWidth: 100, width: 100 }}
                  inputVariant="outlined"
                  disableFuture={false}
                  openTo="year"
                  format="DD-MM-YYYY"
                  label="Start date"
                  views={["year", "month", "date"]}
                  name={`document.WorkExperienceTable[${index}].PreiodFrom`}
                  value={
                    formik.values.document.WorkExperienceTable[index]
                      ?.PreiodFrom || null
                  }
                  onChange={(date) => {
                    formik.setFieldValue(
                      `document.WorkExperienceTable[${index}].PreiodFrom`,
                      date.format("YYYY-MM-DD")
                    );
                  }}
                  error={isError(
                    `document.WorkExperienceTable[${index}].PreiodFrom`,
                    formik
                  )}
                  helperText={getErrorMessage(
                    `document.WorkExperienceTable[${index}].PreiodFrom`,
                    formik
                  )}
                />
                <DatePicker
                  disabled={!canEdit}
                  // className={classes.formControl}
                  style={{ minWidth: 100, width: 100, marginLeft: 8 }}
                  inputVariant="outlined"
                  // disableFuture={false}
                  openTo="year"
                  format="DD-MM-YYYY"
                  label="End date"
                  views={["year", "month", "date"]}
                  name={`document.WorkExperienceTable[${index}].PreiodTo`}
                  value={
                    formik.values.document.WorkExperienceTable[index]
                      ?.PreiodTo || null
                  }
                  onChange={(date) => {
                    formik.setFieldValue(
                      `document.WorkExperienceTable[${index}].PreiodTo`,
                      date.format("YYYY-MM-DD")
                    );
                  }}
                  error={isError(
                    `document.WorkExperienceTable[${index}].PreiodTo`,
                    formik
                  )}
                  helperText={getErrorMessage(
                    `document.WorkExperienceTable[${index}].PreiodTo`,
                    formik
                  )}
                />
              </div>
            </StyledTableCell>
            <StyledTableCell>
              <TextField
                disabled={!canEdit}
                className={classes.textField}
                style={{ width: 150 }}
                variant="outlined"
                name={`document.WorkExperienceTable[${index}].WorkOrganization`}
                value={
                  formik.values.document.WorkExperienceTable[index]
                    ?.WorkOrganization
                }
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(
                  `document.WorkExperienceTable[${index}].WorkOrganization`,
                  formik
                )}
                helperText={getErrorMessage(
                  `document.WorkExperienceTable[${index}].WorkOrganization`,
                  formik
                )}
              />
            </StyledTableCell>
            <StyledTableCell>
              <div style={{ width: 100 }}>
                <SelectCountryDialog
                  disabled={!canEdit}
                  formik={formik}
                  countryFieldName={`document.WorkExperienceTable.${index}.countryId`}
                  cityFieldName={`document.WorkExperienceTable.${index}.WorkCity`}
                />
              </div>
            </StyledTableCell>
            <StyledTableCell>
              <div className={classes.flexRow}>
                <TextField
                  disabled={!canEdit}
                  className={classes.textField}
                  variant="outlined"
                  name={`document.WorkExperienceTable[${index}].WorkResponsibility`}
                  value={
                    formik.values.document.WorkExperienceTable[index]
                      ?.WorkResponsibility
                  }
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError(
                    `document.WorkExperienceTable[${index}].WorkResponsibility`,
                    formik
                  )}
                  helperText={getErrorMessage(
                    `document.WorkExperienceTable[${index}].WorkResponsibility`,
                    formik
                  )}
                />
              </div>
            </StyledTableCell>
            <StyledTableCell disabled={!canEdit} align="center">
              {index === 0 ? (
                <div style={{ width: 40 }} />
              ) : (
                <>
                  <IconButton
                    style={{ width: 40, color: theme.palette.error.main }}
                    size="small"
                    onClick={async () => {
                      if (
                        get(
                          formik.values,
                          `document.WorkExperienceTable[${index}].workId`,
                          ""
                        )
                      ) {
                        formik.setFieldValue(
                          `document.WorkExperienceTable[${index}].Status`,
                          false
                        );
                      } else {
                        formik.setFieldValue(
                          "document.WorkExperienceTable",
                          WorkExperienceTable.filter((__, i) => i !== index)
                        );
                      }
                    }}
                  >
                    <DeleteForeverIcon />
                  </IconButton>
                  <FormHelperText error={false}> </FormHelperText>
                </>
              )}
            </StyledTableCell>
            {/* <StyledTableCell align="center">
              <div
                style={{
                  width: 105,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <UploadButton
                  disabled={!canEdit}
                  title={
                    get(formik.values, `document.WorkExperienceTable[${index}].FileID`, "")
                      ? "Edit"
                      : "+ Add"
                  }
                  id={`upload-${index}`}
                  onChange={async (event) => {
                    try {
                      const response = await FileService.uploadFile({
                        file: event.target.files[0],
                        Status: true,
                      });

                      const fileId = response.results?.fileID;
                      const [filename, ext] =
                        event.target.files[0].name.split(".");

                      formik.setFieldValue(
                        `document.WorkExperienceTable[${index}].FileID`,
                        fileId
                      );
                      formik.setFieldValue(
                        `document.WorkExperienceTable[${index}].filename`,
                        filename
                      );
                      formik.setFieldValue(
                        `WorkExperience[${index}].ext`,
                        `.${ext}`
                      );
                    } catch (error) {
                      console.log("Upload error", error);
                    }
                  }}
                />
                {get(formik.values, `WorkExperience[${index}].FileID`, "") && (
                  <IconButton
                    disabled={!canEdit}
                    style={{ width: 40 }}
                    size="small"
                    onClick={async () => {
                      const fileId = get(
                        formik.values,
                        `WorkExperience[${index}].FileID`,
                        ""
                      );
                      openFileById(fileId);
                    }}
                  >
                    <VisibilityIcon />
                  </IconButton>
                )}
              </div>

              <FormHelperText
                error={isError(`WorkExperience[${index}].FileID`, formik)}
              >
                {getErrorMessage(`WorkExperience[${index}].FileID`, formik)}
              </FormHelperText>
            </StyledTableCell> */}
          </TableRow>
        );
      })}
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <AddRowButton
              disabled={!canEdit}
              onClick={() => {
                formik.setFieldValue("document.WorkExperienceTable", [
                  ...WorkExperienceTable,
                  defaultWorkExperience,
                ]);
              }}
            />
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
